import { PAY, PAY_SUCCESS, PAY_FAILURE } from '../actions/checkout';

export const checkoutInitialState = {
  options: null,
};

export default (state = checkoutInitialState, { type, result, payload }) => {
  switch (type) {
    case PAY: {
      return {
        ...state,
        options: result
      };
    }

    case PAY_SUCCESS: {
      return {
        ...state,
      };
    }

    case PAY_FAILURE: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
